import React from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { LuClock } from 'react-icons/lu';
import { PendingActionType } from '@/client';
import { EXPIRED_OFFER_COPY } from './chatPendingActionCopy';

interface ChatExpiredOfferNoticeProps {
	/** The kind of offer this turn made — see AssistantQuery.offeredAction for when this renders. */
	offeredAction: PendingActionType;
}

/**
 * Explains a dangling question in a historical answer: the turn asked something (a correction
 * offer, a which-one selection), but the offer is no longer live — taken, superseded, aged out, or
 * the session lapsed. Never renders controls: an expired offer's options may name a document or
 * quote text the backend no longer accepts, so there is nothing safe to click here (see
 * docs/local/chat-feature.md §C2). Rendered alongside the original answer text, not instead of it —
 * the question itself is still part of the historical record.
 */
const ChatExpiredOfferNotice: React.FC<ChatExpiredOfferNoticeProps> = (props: ChatExpiredOfferNoticeProps) => {
	const { offeredAction } = props;

	return (
		<HStack gap={1.5} color="fg.muted" fontSize="xs" mt={1}>
			<Icon as={LuClock} boxSize={3.5} />
			<Text>{EXPIRED_OFFER_COPY[offeredAction]}</Text>
		</HStack>
	);
};

export default ChatExpiredOfferNotice;
